import styled from 'styled-components';
import Link from 'next/link';
import {
  BodyMedBold,
  BodySmBold,
  DisplaySmMobileReg,
  TitleLgReg,
} from '@seed-health/tokens';
import { mqLargeMin } from 'styled/tools/media-queries';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-32);
  padding: var(--spacing-56) var(--spacing-16);
  background-color: var(--fill-tertiary);
  color: var(--text-primary);

  @media ${mqLargeMin} {
    gap: var(--spacing-48);
    padding: 90px var(--spacing-56) 126px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);

  @media ${mqLargeMin} {
    align-items: center;
    text-align: center;
  }
`;

export const Heading = styled.h2`
  ${TitleLgReg}
  margin: 0;
  color: var(--text-primary);

  @media ${mqLargeMin} {
    ${DisplaySmMobileReg}
  }
`;

export const Body = styled.p`
  ${BodyMedBold}
  margin: 0;
  color: var(--text-primary);
`;

export const ShopAll = styled(Link)`
  font: inherit;
  letter-spacing: inherit;
  color: inherit;
  text-decoration: underline;

  &:hover,
  &:focus {
    color: inherit;
  }
`;

export const Items = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-32) var(--spacing-16);
  margin: 0;
  padding: 0;
  list-style: none;

  @media ${mqLargeMin} {
    grid-template-columns: repeat(4, 1fr);
    gap: 0;
  }
`;

// The Shop Now link stretches over the whole item, so the jar and copy are clickable
// while the button stays the only link and tab stop
export const Item = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-4);
  cursor: pointer;

  a::after {
    content: '';
    position: absolute;
    inset: 0;
  }
`;

export const Media = styled.div`
  width: 160px;
  height: 160px;

  @media ${mqLargeMin} {
    width: 208px;
    height: 208px;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-16);

  @media ${mqLargeMin} {
    gap: var(--spacing-24);
  }
`;

export const Copy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-4);
  text-align: center;

  @media ${mqLargeMin} {
    gap: var(--spacing-8);
  }
`;

export const Benefit = styled.p`
  ${BodySmBold}
  margin: 0;
  color: var(--text-primary);
`;
